/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Directory/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import ArrowRight from 'DesignSystem/Svgs/ArrowRight/index'
import ButtonBreadcrumbUnder from 'DesignSystem/ButtonBreadcrumbUnder/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Directory({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/Patients/Content/Breadcrumb/Documents/Directory"
  
}) {
let patientDocumentsDirectoryNameValueData = fromData.useDataValue({ viewPath,
context: 'patient_documents_directory',
path: 'name',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Directory.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<ArrowRight
  viewPath={`${viewPath}/ArrowRight`}
 width={14}
 height={14}
 marginLeft={16}
 marginRight={16}
 stroke="rgba(0,0,0,0.3)"
/>
<ButtonBreadcrumbUnder
  viewPath={`${viewPath}/ButtonBreadcrumbUnder`}
 onClick={onClick}
 data="patient_documents_directory.name"
 text={patientDocumentsDirectoryNameValueData}
/>
</div>
{children}
</React.Fragment>)
}